export default __webpack_public_path__ + "static/media/media.5b04075c.png";